import { render, staticRenderFns } from "./createdFour.vue?vue&type=template&id=64d40b48&scoped=true"
import script from "./createdFour.vue?vue&type=script&lang=js"
export * from "./createdFour.vue?vue&type=script&lang=js"
import style0 from "./createdFour.vue?vue&type=style&index=0&id=64d40b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d40b48",
  null
  
)

export default component.exports